var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M24.463 9H7.368A2.37 2.37 0 0 0 5 11.368v9.607a2.37 2.37 0 0 0 2.368 2.368h17.095a2.37 2.37 0 0 0 2.368-2.368v-9.607A2.37 2.37 0 0 0 24.463 9zM7.368 10.246h17.095c.618 0 1.122.504 1.122 1.122v1.179l-8.341 5.82c-.183.134-.773.481-1.303.481-.736 0-1.241-.406-1.242-.407l-8.453-5.825v-1.248c0-.619.504-1.122 1.122-1.122zm17.095 11.85H7.368a1.123 1.123 0 0 1-1.122-1.121v-6.846l7.675 5.286c.17.136.919.68 2.02.68 1.039 0 1.944-.651 2.03-.715l7.614-5.314v6.91c0 .617-.504 1.12-1.122 1.12z",
    opacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b4d5c18cb0c9db50de33d42740fd9d38.svg";
export { ForwardRef as ReactComponent };